import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Layout } from '../../../components'

import { UserStep } from './UserStep'
import { Creating } from './Creating'
import { Finished } from './Finished'

import { getStep, init } from './state'
import { Paths } from '../constants'
import { AcceptInvitationQueryParams, AcceptInvitationUrlParams } from './types'
import { useProvideStepAnalytics } from '../../../hooks/useStepAnalytics'
import { useQueryParams } from '../../../hooks/useQueryParams'
import { usePathMetadata } from '../../../hooks/usePathMetadata'
import { FROM_MOBILE_APP_KEY, setItemSafe } from '../../../helpers/localStorage'
import { AcceptInvitationSteps } from './AcceptInvitationSteps'

const STEP_TO_COMPONENT: { [key in AcceptInvitationSteps]: React.ElementType } =
  {
    [AcceptInvitationSteps.UserStep]: UserStep,
    [AcceptInvitationSteps.Creating]: Creating,
    [AcceptInvitationSteps.Finished]: Finished,
  }

export function OrganizationJoinFromInvitation({
  superEnabled = false,
}: {
  superEnabled?: boolean
}) {
  const dispatch = useDispatch()
  const { inviteToken } = useParams<AcceptInvitationUrlParams>()
  const {
    displayName,
    mobile: fromMobileApp,
    organizationId,
  } = useQueryParams<AcceptInvitationQueryParams>()

  const path = Paths.Accept
  const Metadata = usePathMetadata(path)
  const step: keyof typeof STEP_TO_COMPONENT = useSelector(getStep)
  const StepComponent = STEP_TO_COMPONENT[step]

  useProvideStepAnalytics(path)

  useEffect(() => {
    if (fromMobileApp) {
      setItemSafe(FROM_MOBILE_APP_KEY, fromMobileApp)
    }
  }, [fromMobileApp])

  useEffect(() => {
    dispatch(init({ inviteToken, displayName, organizationId }))
  }, [dispatch, inviteToken, displayName, organizationId])

  return (
    <>
      <Metadata />
      <Layout superEnabled={superEnabled}>
        <StepComponent superEnabled={superEnabled} />
      </Layout>
    </>
  )
}
